<template>
  <div class="connect-container">
    <div class="container">
      <el-card class="main-container">
        <div class="main-header">
          <div class="main-header-left">
            <span>{{$t('connections')}}</span>
            <button @click="add" :class="{'de1':isDe}">{{$t('Add Connection')}}</button>
          </div>
        </div>
        <!--表格-->
        <div :element-loading-text="loadingText" v-loading.fullscreen.lock="loading" >
        <div class="patient-table">
          <table id="patientList">
            <tr class="header">
              <td>{{$t('Name')}}</td> <td>{{$t('SG')}}<br>({{unit}})</td>
              <td>{{$t('basal')}}<br>{{$t('basal_unit')}}</td><td>{{$t('Active Insulin')}}<br>{{$t('ins_unit')}}</td>
              <td>{{$t('Action')}}</td>
            </tr>
            <tr v-for="(item,index) in connections" :class="(index%2===0) ? '':'even'" :id="index">
              <td class="name" @click="go" :id="index">
                <img class="portrait" :src="'/api/v2.0/person/'+item.uid+'/portrait'">
                <p class="name1">{{item.alias}}</p></td>
              <td>{{item.sensor_status.glucose}}</td><td>{{item.pump_status.basalRate}}</td><td>{{item.pump_status.iob}}</td>
              <td class="name" @click="StopFollow" style="cursor: pointer">{{$t('Stop following')}}</td>
            </tr>
          </table>
        </div>
        </div>
        <!--分页-->
        <div class="patientList-block">
          <img src="../../assets/arrow_right.png" :class="{'click1': !has_prev}" @click="prevPage">
          <span> <input v-model="page" @keyup.13="goPage" @blur='goPage'> of &nbsp;&nbsp;{{pages}}</span>
          <img src="../../assets/arrow_left.png" :class="{'click1': !has_next}" @click="nextPage">
        </div>
      </el-card>
    </div>

    <div class="Hcp-footer">
      <span>
<!--        <a href="http://www.medtrum.com/index.php/abouts">{{ $t('contact us') }} </a>-->
<!--           <a v-if="!isEU" href="http://www.medtrum.com/privacy_policy.html">|  {{ $t('Privacy Policy') }} </a>-->
<!--           <a v-if="!isEU" href="http://www.medtrum.com/terms_of_use.html">|  {{ $t('Terms of Use') }} | </a>-->
<!--           <a v-if="isEU" href="http://www.medtrum.co.uk/privacy_policy.html">|  {{ $t('Privacy Policy') }} </a>-->
<!--           <a v-if="isEU" href="http://www.medtrum.co.uk/terms_of_use.html">|  {{ $t('Terms of Use') }} | </a>-->
                      <a :href="contactURL">{{ $t('contact us') }} </a>
              <a :href="privacyURL">|  {{ $t('Privacy Policy') }} </a>
              <a :href="termsOfUseURL">|  {{ $t('Terms of Use') }} | </a>

           {{$t('copyright')}}<br/>
          <a v-show="isZh" target=_blank href="http://beian.miit.gov.cn/"> 沪ICP备08013753号-3  </a>
          <img v-show="isZh" src="/static/beian.png" />
          <a v-show="isZh" target=_blank href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"> 沪公网安备 31011502014155号 </a>
      </span>
    </div>

    <!--时间选择对话框-->
    <el-dialog  :visible.sync="showConfirmDialog" :size=dialogSize  id="dialog-form2"
                :show-close="false" :close-on-click-modal="false">
      <div class="dialog-title">
        <p>{{$t('privacy_policy_and_terms_of_use')}}</p>
      </div>

      <div class="dialog-content">
        <p v-html="$t('privacy_confirm_text')"></p>
      </div>

      <div class="dialog-footer">
        <button @click="denyPrivacyConfirm" class="deny">{{$t('privacy_confirm_disagree')}}</button>
        <button @click="agreePrivacyConfirm" class="agree">{{$t('privacy_confirm_accept')}}</button>
        <div style="clear: both;"></div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import auth from '../../auth/auth'
  export default {
    name: 'home1',
    data () {
      return {
        dialogSize:'small',
        activeIndex: '1',loading:false,loadingText:this.$t('Loading'),
        pages:'', page:1, has_next:'', has_prev:'',unit:'',isDe:false,isZh:false,
        connections:[],
        isEU:true,
        showConfirmDialog:false,
        contactURL:'',
        privacyURL:'',
        termsOfUseURL:'',
      }
    },

    computed:{
      users(){
        return this.$store.state.users;
      }
    },
    methods: {
      add(){
        this.$router.push('/addConnection');
      },
      go(e){
        let index = e.target.parentNode.id;
        let uid = this.connections[index].uid;
        let name = this.connections[index].alias;
        sessionStorage.setItem('patientId',uid);
        sessionStorage.setItem('patientName',name);
        this.$router.push('/monitor');
      },
      StopFollow(e){
        let index = e.target.parentNode.id;
        let uid = this.connections[index].uid;
        let tip = this.$t('stopFollow');
        let tip1 = this.$t('confirm');
        let tip2 = this.$t('Yes');
        let tip3 = this.$t('Cancel');
        this.$confirm(tip, tip1, {
          confirmButtonText: tip2,
          cancelButtonText: tip3,
          type: 'warning'
        }).then(() => {
           this.$http.post('api/v2.0/relations/monitor/cancel',{uid:uid}).then(function(res){
            let err =res.body.error;
            if(err===0){
              this.$message({
                type: 'success',
                message: 'Stop following succeed!'
              });
              auth.getConnections(this,{page:this.page});
            }else{
             this.$message.error('Stop following failed!');
            }
          })
        },function () {

        });

      },
      //下一页
      nextPage(){
        if(this.page<this.pages){
          this.page++;
          this.getConnections();
        }
      },
      //上一页
      prevPage(){
        if(this.page>1){
          this.page--;
          this.getConnections();
        }
      },
      //输入页码跳转
      goPage(){
        if(0<this.page&&this.page<this.pages+1){
          this.getConnections();
        }else{
          this.page = 1;
          this.getConnections();
        }
      },
      openFullScreen(){
        this.loading = true;
        setTimeout(()=>{
          this.loading = false;
        },2000);
      },
      getConnections(){
        let para = {
          page: this.page,
        };
        this.openFullScreen();
        auth.getConnections(this,para);
      },
      checkPrivacyVersion() {
        this.$http.get('/api/v2.1/user/privacy/confirm').then(function(res){
          console.log("privacy confirm:", res.data);
          if (0==res.data.error) {
            if (0==res.data.confirm) {
              this.showConfirmDialog=true;
            }
          }
        }, function(err){

        })
      },
      denyPrivacyConfirm(){
        this.showConfirmDialog=false;
      },
      agreePrivacyConfirm(){
        this.showConfirmDialog=false;
        this.$http.post('/api/v2.1/user/privacy/confirm').then(function (res) {
          console.log('privacy confirm:', res.data)
        },function (err) {

        })
      }
    },
    mounted:function () {
      this.getConnections();
      this.unit = (localStorage.getItem('unit')==='mg')?'mg/dL':'mmol/L';
      this.isDe = (sessionStorage.getItem('language')==='de')?true:false;
      this.isZh = (sessionStorage.getItem('language')==='zh')?true:false;
      let countryIndex=localStorage.getItem('index');
      //console.info('countryIndex:'+countryIndex);
      if (1==countryIndex || 6==countryIndex || 14==countryIndex) {
        this.isEU=false;
      }
      //
      this.checkPrivacyVersion();
      setTimeout(()=>{
        let host=auth.getOuterHost();
        this.contactURL = host+'/contact.html';
        this.privacyURL = host+'/privacy_policy.html';
        this.termsOfUseURL = host + '/terms_of_use.html';
      }, 50)
    },
  }
</script>

<style scoped>
  .connect-container{
    width:100%;
    min-height:889px;
    background-color:#fff;
  }
  .container{
    width:62%;
    margin:0 auto;
    background:#fafbfc;
    padding-top: 15px;
  }
  @media screen and (max-width: 1500px){
    .container{
      width:92%;
    }
  }
  @media screen and (min-height: 950px){
    .container{
      min-height:904px;
    }
  }
  .main-container{
    width:97%;
    height: 840px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
    border: none;
    background:#fff;
    position: relative;
  }
  .main-header{
    width: 98%;
    margin:-5px auto 0;
    height:20px;
    margin-bottom: 15px;
  }
  .main-header-left{
    float: left;
    height:20px;
    line-height: 20px;
    border-left: 2px solid #005dac;
  }
  .main-header-left span{
    margin-left:10px;
  }
  .main-header-left button{
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    letter-spacing:-0.39px;
    text-align:center;
    border-radius:100px;
    width:156px;
    margin-left: 40px;
    height:28px;
    background: transparent;
    border:1px solid #a3a3a3;
    outline: none;
    cursor: pointer;
  }
  .main-header-left .de1{
    width:172px;
  }


  /*表格*/
  .patient-table{
    width:100%;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:16px;
    color: #282828;
    letter-spacing:-0.44px;
    text-align:center;
    margin-top: 25px;
  }
  table{
    width:100%;
    table-layout: fixed;
    border-collapse: collapse;
  }
  .portrait{
    border-radius:100px;
    width:36px;
    height:36px;
    float: left;
    margin-left: 13%;
    margin-right: 6%;
    cursor: pointer;
  }
  .name .name1{
    float: left;
    margin-top: 10px;
    cursor: pointer;
  }
  .patient-table .header{
    color:#005dac;
    height:70px;
    background:#cfdff0;
    font-size:18px;
  }
  tr{
    height: 60px;
    font-size:16px;
    letter-spacing:-0.39px;
    text-align:center;
  }
  table .name{
    color:#005dac;
  }
  .even{
    background:#ebeef1;
  }

  /*分页*/
  .patientList-block{
    margin-top:15px;
    height:20px;
    width: 208px;
    letter-spacing:-0.44px;
    position: absolute;
    bottom: 10px;
    left: 30px;
  }
  .patientList-block img{
    cursor: pointer;
    float: left;
  }
  .patientList-block span{
    float: left;
    display: block;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
    text-align:left;
    margin: -2px 20px 0;
  }
  .patientList-block input{
    font-family:SFUIText-Regular;
    font-size:18px;
    height:18px;
    width:40px;
    margin-right: 20px;
    text-align: center;
  }
  .patientList-block .click1{
    opacity: 0.3;
    cursor:auto;
  }


  /*分页*/
  .patientList-block{
    margin-top:15px;
    height:20px;
    width: 208px;
    letter-spacing:-0.44px;
    position: absolute;
    bottom: 15px;
  }
  .patientList-block img{
    cursor: pointer;
    float: left;
  }
  .patientList-block span{
    float: left;
    display: block;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
    text-align:left;
    margin: -2px 20px 0;
  }
  .patientList-block input{
    font-family:SFUIText-Regular;
    font-size:18px;
    height:18px;
    width:36px;
    margin-right: 20px;
    text-align: center;
  }
  .patientList-block .click1{
    opacity: 0.3;
    cursor:auto;
  }

  .Hcp-footer{
    font-family:HelveticaNeue;
    font-size:14px;
    color:rgba(120,120,120,0.90);
    letter-spacing:-0.34px;
    text-align:center;
    margin-top: 13px;
  }
  .Hcp-footer a{
    color:rgba(120,120,120,0.90);
    text-decoration: none;
  }
  .Hcp-footer a:hover{
    color:#0090D3;
  }

  .dialog-title {
    margin-bottom: 30px;
    font-size:18px;
    font-weight: bold;
  }

  .dialog-footer{
    margin:35px auto 0px;
    width:90%;
  }
  .dialog-footer button{
    *background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    box-shadow:0 3px 4px 0 #c6e1ff;
    color:#fff;
    margin:0 auto;
    border-radius:3px;
    width:20%;
    height:30px;
    border:none;
    outline: none;
    cursor: pointer;
  }

  .dialog-footer .deny {
    float:left;
    background-color:#888;
  }

  .dialog-footer .agree {
    float:right;
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
  }
</style>



// WEBPACK FOOTER //
// carer-connect.vue?5b8ed9d5